import axios from 'axios'
import routes from '@/router'
import store from '@/vuex/store'
import { Message } from 'element-ui'
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/utils/auth'
import URL from '@/api/baseUrl.js'
export const http = axios.create({
  baseURL: URL,
  timeout: 1000 * 10,
  loading: false,
});


// 请求拦截器,在请求发出之前进行一些操作
http.interceptors.request.use(function (config) {
  let token = store.state.token
  let communityId = ''
  if (store.state.userInfo) {
    communityId = store.state.userInfo.communityId;
  }
  if (config.url.split('?')[0] !== '/login') {
    config.headers['Authorization'] = token;
    config.headers['cId'] = communityId;
    if (config.headers['Authorization'] == null) {
      routes.replace({ path: '/login' }) // 到登录页重新获取token
    }
    // 是否显示loading效果
    if (config.loading) {
      http.showLoading = true;
      showFullScreenLoading();
    }
  }
  return config
}, function (error) {
  Message.error('请求失败,请重试');
  tryHideFullScreenLoading();
  return Promise.reject(error)
});



//响应拦截器异常处理
http.interceptors.response.use(response => {
  if (response && response.data.code!==200 && response.data.code!==1) {
    if (response.data.code === 401) {
      sessionStorage.clear();
      store.commit('DEL_TOKEN');
      routes.replace({ path: '/login' });
    }
    Message.error(`${response.data.message}`)
  } else if (!response) {
    Message.error(`连接错误`)
  }
  tryHideFullScreenLoading()
  return response.data;
}, err => {
  tryHideFullScreenLoading()
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        Message.error('错误请求');
        break;
      case 404:
        Message.error('当前资源不存在');
        break;
      case 500:
        Message.error('服务器忙，请重试');
        break;
      case 401:
        Message.error('未授权，请重新登录');
        sessionStorage.clear();
        store.commit('DEL_TOKEN');
        routes.replace({ path: '/login' });
        break;
      case 403:
        Message.error('抱歉!您没有该权限');
        break;
      case 408:
        Message.error('请求超时');
        break;
      case 502:
        Message.error('网络错误');
        break;
      case 503:
        Message.error('服务不可用');
        break;
      default:
        Message.error(`连接错误`);
    }
  } else {
    Message.error(`当前网络不可用 请稍后重试`)
  }
  return false
});

http.all = axios.all;

//定义插件的配置来扩展 Vue 本身
const httpPlugin = {};
httpPlugin.install = function (Vue, options) {
  Vue.prototype.$http = http
};

export default httpPlugin
